import * as React from 'react';
import { AppLayoutSettings } from '../../common/styles/common.styles';
import { IStyleFunctionOrObject, IMessageBarStyleProps, IMessageBarStyles } from 'office-ui-fabric-react'

export const getRecordingContainerStyles = (): React.CSSProperties => {
  return {
    marginTop: '110px'
  };
};

export const getWarningMessageBarStyles = (): React.CSSProperties => {
  return {
    position: "relative",
    marginTop: '20px'
  }
}

export const getPrivacyDisclaimerStyles = (): IStyleFunctionOrObject<IMessageBarStyleProps, IMessageBarStyles> => {
  return {
    // Show no icon in the privacy disclaimer
    icon: {
      display: 'none',
    },

    root: {
      background: AppLayoutSettings.getAppColorContainer().popupBackground.value
    }
  }
}

export const getBackupDisabledStyles = (): IStyleFunctionOrObject<IMessageBarStyleProps, IMessageBarStyles> => {
  return {
    // Show no icon in the privacy disclaimer
    icon: {
      display: 'none',
    },

    root: {
      background: AppLayoutSettings.getAppColorContainer().popupBackground.value
    }
  }
}

export const getPrivacyDisclaimerTextStyles = () => {
  return {
    root: {
      color: AppLayoutSettings.getAppColorContainer().whiteColor.value,

      // Since the privacy disclaimer is white text on dark background, we need to make sure a dark high contrast color is shown when in white theme.
      // The prefers-contrast CSS media feature is used to detect whether the user has requested the web content to be
      // presented with a lower or higher contrast. More Info :- https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
      selectors: {
        ['@media (prefers-contrast: more)']: {
          color: 'windowText'
        }
      }
    }
  }
}

export const getBackupDisabledTextStyles = () => {
  return {
    root: {
      color: AppLayoutSettings.getAppColorContainer().whiteColor.value,

      // Since the backup disabled is white text on dark background, we need to make sure a dark high contrast color is shown when in white theme.
      selectors: {
        ['@media screen and (-ms-high-contrast: black-on-white)']: {
          color: 'windowText'
        }
      }
    }
  }
}

export const getPrivacyPolicyLinkStyle = () => {
  return {
    color: AppLayoutSettings.getAppColorContainer().whiteColor.value,
    textDecoration: 'underline',
    selectors: {
      [`.ms-Fabric--isFocusVisible & :focus`]: {
        boxShadow: 'none',
        outline: `${AppLayoutSettings.getAppColorContainer().whiteColor.value} solid 1px !important`
      }
    }
  }
}

export const getNeedHelpLinkStyle = (): React.CSSProperties => {
  return {
    color: AppLayoutSettings.getAppColorContainer().linkColor.value,
    fontSize: '12px',
    textDecoration: 'underline'
  }
}

export const getMicrophoneImageContainerStyle = (): React.CSSProperties => {
  return {
    height: '63px',
    bottom: '12px'
  }
}